import { render, staticRenderFns } from "./date-range-widget.vue?vue&type=template&id=564e8f95&scoped=true"
import script from "./date-range-widget.vue?vue&type=script&lang=js"
export * from "./date-range-widget.vue?vue&type=script&lang=js"
import style0 from "./date-range-widget.vue?vue&type=style&index=0&id=564e8f95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e8f95",
  null
  
)

export default component.exports